import { Stack, Typography } from "@mui/material";
import type { FC } from "react";
import type { GetTaskWorkflowResponse } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { TaskPhaseBlock } from "web_myplann/Tasks/Components/TaskPhaseBlock";

const R = Resources.Task.Detail;

type Props = {
	phases: GetTaskWorkflowResponse[];
};

export const TaskProcessSection: FC<Props> = ({ phases }) => {
	const { t } = useResource();

	if (phases.length === 0) {
		return null;
	}

	return (
		<>
			<Typography variant="sectionLabel">{t(R.Process.title)}</Typography>
			<Stack bgcolor="background.paper">
				{phases.map((phase, index) => (
					<TaskPhaseBlock
						key={phase.taskWorkflowID}
						name={phase.name}
						steps={phase.steps}
						showDivider={index < phases.length - 1}
					/>
				))}
			</Stack>
		</>
	);
};
